import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

const lookupsAdapter = createEntityAdapter();

const initialState = lookupsAdapter.getInitialState({
	status: "idle",
	error: null,
});

const lookupsSlice = createSlice({
	name: "lookups",
	initialState,
	reducers: {
		lookupsReceived(state, action) {
			lookupsAdapter.setAll(state, action.payload);
		},
		lookupsUpserted(state, action) {
			lookupsAdapter.upsertMany(state, action.payload);
		},
	},
});

/*
ACTIONS
*/
export const { lookupsReceived, lookupsUpserted } = lookupsSlice.actions;

/*
SELECTORS
*/
export const { selectAll: selectAllLookups, selectById: selectLookupById } =
	lookupsAdapter.getSelectors((state) => state.lookups);

/*
CUSTOM SELECTORS
*/
export const selectLookupsError = (state) => state.lookups.error;

export default lookupsSlice.reducer;
